module.exports = __webpack_public_path__ + "static/img/LOGO.60b91820.png";